import { render, staticRenderFns } from "./araucaria.vue?vue&type=template&id=040a7556&"
import script from "./araucaria.vue?vue&type=script&lang=js&"
export * from "./araucaria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports